import { render, staticRenderFns } from "./aboutWmdyj.vue?vue&type=template&id=7147c4d8&scoped=true&"
import script from "./aboutWmdyj.vue?vue&type=script&lang=js&"
export * from "./aboutWmdyj.vue?vue&type=script&lang=js&"
import style0 from "./aboutWmdyj.vue?vue&type=style&index=0&id=7147c4d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7147c4d8",
  null
  
)

export default component.exports